import { component } from "picoapp";

export const megaMenu = component((node: HTMLElement) => {
  const overlay = document.querySelector<HTMLElement>(".overlay");

  const openDropdown = (
    dropdownLink: HTMLElement,
    navDropdown: HTMLElement,
    overlay: HTMLElement,
    dropdownContainer: HTMLElement,
    node: HTMLElement
  ) => {
    dropdownLink.ariaExpanded = "true";
    node.querySelector(".header").classList.add("is-dropdown-open");
    node.classList.add("dropdown-active");
    overlay.classList.add("is-active");
    dropdownContainer
      .querySelector(".site-nav-dropdown__menu--active")
      .classList.remove("site-nav-dropdown__menu--active");

    navDropdown.classList.add("site-nav-dropdown__menu--active");

    dropdownContainer.classList.remove("tw-hidden");
    setTimeout(() => {
      dropdownContainer.classList.add("tw-opacity-100");
    }, 0);
  };

  const closeDropdown = (
    dropdownLink: HTMLElement,
    navDropdown: HTMLElement,
    overlay: HTMLElement,
    dropdownContainer: HTMLElement,
    node: HTMLElement
  ) => {
    if (
      !node.querySelector(".site-nav-dropdown:hover") &&
      !node.querySelector("#SiteNav li.site-nav--has-dropdown:hover")
    ) {
      dropdownLink.ariaExpanded = "false";
      node.querySelector(".header").classList.remove("is-dropdown-open");
      node.classList.remove("dropdown-active");
      overlay.classList.remove("is-active");
      dropdownContainer
        .querySelector(".site-nav-dropdown__menu--active")
        .classList.remove("site-nav-dropdown__menu--active");
      navDropdown.classList.add("site-nav-dropdown__menu--active");
      dropdownContainer.classList.remove("tw-opacity-100");
      setTimeout(() => {
        dropdownContainer.classList.add("tw-hidden");
      }, 0);
    }
  };

  const toggleInnerDropdown = (e: Event, innerDropdownButtons: NodeList) => {
    e.preventDefault();
    innerDropdownButtons.forEach((button: HTMLElement) => {
      const innerDropdownMenuClasslist = document.getElementById(
        button.getAttribute("data-handle")
      ).classList;
      const nestedButton = button.firstElementChild;

      if (e.target === nestedButton || e.target === button) {
        nestedButton.ariaExpanded = "true";
        button.classList.add("site-nav-dropdown__child-link--active");
        innerDropdownMenuClasslist.add("site-nav-dropdown__child-menu--active");
      } else {
        nestedButton.ariaExpanded = "false";
        button.classList.remove("site-nav-dropdown__child-link--active");
        innerDropdownMenuClasslist.remove(
          "site-nav-dropdown__child-menu--active"
        );
      }
    });
  };

  const handleInnerDropdownKeypress = (
    e: KeyboardEvent,
    innerDropdownButtons: NodeList
  ) => {
    const { code } = e;
    if (code !== "Tab") e.preventDefault();
    if (code === "Space" || code === "Enter") {
      toggleInnerDropdown(e, innerDropdownButtons);
    }
  };

  const handleKeypress = (
    dropdownLink: HTMLElement,
    e: KeyboardEvent,
    navDropdown: HTMLElement,
    overlay: HTMLElement,
    dropdownContainer: HTMLElement,
    node: HTMLElement
  ) => {
    const { code } = e;
    if (code !== "Tab") e.preventDefault();
    const forceClose = code === "Escape";
    if (code === "Space" || code === "Enter" || forceClose) {
      overlay.classList.contains("is-active") || forceClose
        ? closeDropdown(
            dropdownLink,
            navDropdown,
            overlay,
            dropdownContainer,
            node
          )
        : openDropdown(
            dropdownLink,
            navDropdown,
            overlay,
            dropdownContainer,
            node
          );
    }
  };

  const initNav = (node: HTMLElement, overlay: HTMLElement) => {
    node
      .querySelectorAll<HTMLElement>(".site-nav > .site-nav--has-dropdown")
      .forEach((dropdownLink, idx) => {
        const dropdownContainer =
          node.querySelector<HTMLElement>(".site-nav-dropdown");
        const linkName = dropdownLink.getAttribute("data-child-list-handle");
        const navDropdown = node.querySelector<HTMLElement>(
          `.site-nav-dropdown__menu--${linkName}`
        );

        if (idx === 0) {
          navDropdown.classList.add("site-nav-dropdown__menu--active");
        }
        dropdownLink.firstElementChild.addEventListener(
          "keydown",
          (e: KeyboardEvent) =>
            handleKeypress(
              dropdownLink,
              e,
              navDropdown,
              overlay,
              dropdownContainer,
              node
            )
        );
        dropdownLink.firstElementChild.addEventListener("mouseenter", () =>
          openDropdown(
            dropdownLink,
            navDropdown,
            overlay,
            dropdownContainer,
            node
          )
        );
        dropdownLink.addEventListener("mouseleave", () =>
          closeDropdown(
            dropdownLink,
            navDropdown,
            overlay,
            dropdownContainer,
            node
          )
        );
        navDropdown.addEventListener("mouseleave", () =>
          closeDropdown(
            dropdownLink,
            navDropdown,
            overlay,
            dropdownContainer,
            node
          )
        );

        const innerDropdownButtons = navDropdown.querySelectorAll(
          ".site-nav-dropdown__link-parent"
        );
        if (innerDropdownButtons.length) {
          innerDropdownButtons.forEach((button, idx) => {
            if (idx === 0) {
              button.classList.add("site-nav-dropdown__child-link--active");
              document
                .getElementById(button.getAttribute("data-handle"))
                .classList.add("site-nav-dropdown__child-menu--active");
            }

            button.addEventListener("keydown", (e: KeyboardEvent) =>
              handleInnerDropdownKeypress(e, innerDropdownButtons)
            );
            button.addEventListener("mouseenter", (e) =>
              toggleInnerDropdown(e, innerDropdownButtons)
            );
          });
        }

        return () => {
          dropdownLink.firstElementChild.removeEventListener(
            "keydown",
            (e: KeyboardEvent) =>
              handleKeypress(
                dropdownLink,
                e,
                navDropdown,
                overlay,
                dropdownContainer,
                node
              )
          );
          dropdownLink.firstElementChild.removeEventListener("mouseenter", () =>
            openDropdown(
              dropdownLink,
              navDropdown,
              overlay,
              dropdownContainer,
              node
            )
          );
          dropdownLink.removeEventListener("mouseleave", () =>
            closeDropdown(
              dropdownLink,
              navDropdown,
              overlay,
              dropdownContainer,
              node
            )
          );
          navDropdown.removeEventListener("mouseleave", () =>
            closeDropdown(
              dropdownLink,
              navDropdown,
              overlay,
              dropdownContainer,
              node
            )
          );
          innerDropdownButtons.forEach((button) => {
            button.removeEventListener("keydown", (e: KeyboardEvent) =>
              toggleInnerDropdown(e, innerDropdownButtons)
            );
          });
        };
      });
  };

  initNav(node, overlay);
});
